"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function simpleClickHandler(event, interactionHandler, dataAttributePrefix, link) {
  interactionHandler(event, "".concat(dataAttributePrefix, "-").concat(link.id));
  if (!link.onClick) return;
  link.onClick();
}

var _default = simpleClickHandler;
exports["default"] = _default;
//# sourceMappingURL=simpleClickHandler.js.map